import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';
import { VISIBILITY_FEATURE } from './constants';

const VisibilityAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  featureRestriction: VISIBILITY_FEATURE,
  routes: [
    {
      path: routesUrl.visibilitySettings,
      exact: true,
      component: React.lazy(() => import('./pages/SettingsPage')),
    },
    {
      path: routesUrl.visibilityDashboard,
      exact: true,
      component: React.lazy(() => import('./pages/DashboardPage')),
    },
    {
      path: routesUrl.visibilityReviews,
      exact: true,
      component: React.lazy(() => import('./pages/InboxPage')),
    },
    {
      path: routesUrl.visibilityPosts,
      exact: true,
      component: React.lazy(() => import('./pages/PostsPage')),
    },
    {
      path: routesUrl.visibilityAnalytics,
      exact: true,
      component: React.lazy(() => import('./pages/AnalyticsPage')),
    },
    {
      path: routesUrl.visibilityScore,
      exact: true,
      component: React.lazy(() => import('./pages/ScorePage')),
    },
    {
      path: routesUrl.visibility,
      exact: true,
      component: React.lazy(() => import('./pages/ScorePage')),
    },
  ],
};

export default VisibilityAppConfig;
